import { TOKEN_VALIDATION_INTERVAL } from '../constants/token-validation-interval.const';
import { getTokenMillisecondsLeft } from '../utilities/get-token-milliseconds-left';

/**
 * Validates JWT for not being expired. Returns `false` if JWT is about to be expired (5 minutes left).
 * @param token JWT to validate
 * @returns A boolean value indicating whether provided JWT is either expired or is about to be expired.
 */
export const validateJWTToken = (token: string): boolean => {
  const tokenMillisecondsLeft: number = getTokenMillisecondsLeft(token);
  return tokenMillisecondsLeft > TOKEN_VALIDATION_INTERVAL;
};
